<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <h1 class="modern-title">Processos Inteligentes</h1>
                                    <p class="modern-subtitle">Gerencie e acompanhe seus processos de forma inteligente</p>
                                </div>
                                <div class="actions-group">
                                    <div class="buttons-container" :class="{ 'centered': !podeGerenciarProcessos }">
                                        <div class="buttons-row">
                                            <button class="btn btn-primary btn-small" @click="abrirDashboard">
                                                <i class="fas fa-chart-line"></i> Dashboard
                                            </button>
                                            <button @click="abrirCalendario" class="modern-btn modern-btn-secondary">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar3" viewBox="0 0 16 16">
                                                    <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z" />
                                                    <path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                                                </svg>
                                                Agenda
                                            </button>
                                            <button @click="abrirModalProgressao('REVISAO')" class="modern-btn modern-btn-warning">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M20 17H22V15H20V17M20 7V13H22V7M6 16H11V18H6M6 12H14V14H6M4 2C2.89 2 2 2.89 2 4V20C2 21.11 2.89 22 4 22H16C17.11 22 18 21.11 18 20V8L12 2M4 4H11V9H16V20H4Z" />
                                                </svg>
                                                Revisões
                                            </button>
                                            <button @click="abrirModalProgressao('APROVACAO')" class="modern-btn modern-btn-success">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M23.5 17L18.5 22L15 18.5L16.5 17L18.5 19L22 15.5L23.5 17M6 2C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H13.81C13.45 21.38 13.2 20.7 13.08 20H6V4H13V9H18V13.08C18.33 13.03 18.67 13 19 13C19.34 13 19.67 13.03 20 13.08V8L14 2M8 12V14H16V12M8 16V18H13V16Z" />
                                                </svg>
                                                Aprovações
                                            </button>
                                            <button @click="abrirModalProgressao('ASSINATURA')" class="modern-btn modern-btn-signature">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M19.7 12.9L14 18.6H11.7V16.3L17.4 10.6L19.7 12.9M23.1 12.1C23.1 12.4 22.8 12.7 22.5 13L20 15.5L19.1 14.6L21.7 12L21.1 11.4L20.4 12.1L18.1 9.8L20.3 7.7C20.5 7.5 20.9 7.5 21.2 7.7L22.6 9.1C22.8 9.3 22.8 9.7 22.6 10C22.4 10.2 22.2 10.4 22.2 10.6C22.2 10.8 22.4 11 22.6 11.2C22.9 11.5 23.2 11.8 23.1 12.1M3 20V4H10V9H15V10.5L17 8.5V8L11 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H15C16.1 22 17 21.1 17 20H3M11 17.1C10.8 17.1 10.6 17.2 10.5 17.2L10 15H8.5L6.4 16.7L7 14H5.5L4.5 19H6L8.9 16.4L9.5 18.7H10.5L11 18.6V17.1Z" />
                                                </svg>
                                                Assinaturas
                                            </button>
                                        </div>
                                        <div class="status-badge" @click="abrirStatusArtefatos">
                                            <div class="badge-content">
                                                <span class="badge-label">Status individual de cada artefato</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="usage-badge" v-if="utilizacoes">
                                        <div class="badge-content">
                                            <span class="badge-label">Total de Processos</span>
                                            <div class="badge-numbers">
                                                <span class="number-current">{{utilizacoes.qtdRealizados}}</span>
                                                <span class="number-separator">/</span>
                                                <span class="number-total">{{utilizacoes.qtdLiberados}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div><!-- modern-header -->
                    <div class="table-container">
                        <div class="table-wrapper">
                            <div class="list-toolbar bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                <div class="create-dropdown" @click.stop>
                                    <button type="button"
                                            class="modern-btn modern-btn-primary create-dropdown__toggle"
                                            @click="toggleCreateMenu"
                                            :aria-expanded="showCreateMenu ? 'true' : 'false'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                        </svg>
                                        Novo
                                        <svg class="ms-1" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                        </svg>
                                    </button>

                                    <transition name="fade-scale">
                                        <div v-if="showCreateMenu" class="create-dropdown__menu">
                                            <div class="create-dropdown__header">
                                                <div class="create-dropdown__title">Criar processo</div>
                                                <div class="create-dropdown__subtitle">Escolha a forma de criação para iniciar.</div>
                                            </div>

                                            <button class="create-dropdown__item" type="button" @click="onCreateFromScratch">
                                                <div class="create-dropdown__item-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-file-earmark-text" viewBox="0 0 16 16">
                                                        <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5" />
                                                        <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z" />
                                                    </svg>
                                                </div>
                                                <div class="create-dropdown__item-text">
                                                    <div class="create-dropdown__item-title">Processo com preenchimento manual</div>
                                                    <div class="create-dropdown__item-subtitle">Cadastre o processo informando todos os dados e parâmetros do início ao fim.</div>
                                                </div>
                                            </button>

                                            <button class="create-dropdown__item mt-1" type="button" @click="onCreateFromNecessidade">
                                                <div class="create-dropdown__item-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-file-earmark-check" viewBox="0 0 16 16">
                                                        <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z" />
                                                        <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                                    </svg>
                                                </div>
                                                <div class="create-dropdown__item-text">
                                                    <div class="create-dropdown__item-title">Processo a partir de Registro de Necessidade</div>
                                                    <div class="create-dropdown__item-subtitle">Selecione um registro existente e utilize seus itens para compor o processo.</div>
                                                </div>
                                            </button>

                                            <button class="create-dropdown__item mt-1" type="button" @click="onCreateProcessAndNecessidade">
                                                <div class="create-dropdown__item-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-node-plus" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M11 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6.025 7.5a5 5 0 1 1 0 1H4A1.5 1.5 0 0 1 2.5 10h-1A1.5 1.5 0 0 1 0 8.5v-1A1.5 1.5 0 0 1 1.5 6h1A1.5 1.5 0 0 1 4 7.5zM11 5a.5.5 0 0 1 .5.5v2h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2h-2a.5.5 0 0 1 0-1h2v-2A.5.5 0 0 1 11 5M1.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" />
                                                    </svg>
                                                </div>
                                                <div class="create-dropdown__item-text">
                                                    <div class="create-dropdown__item-title">Processo com Registro de Necessidade integrado com outros setores</div>
                                                    <div class="create-dropdown__item-subtitle">Selecione itens do catálogo, gere o registro de necessidade e crie o processo em sequência.</div>
                                                </div>
                                            </button>
                                        </div>
                                    </transition>
                                </div>

                                <div class="search-row">
                                    <div class="search-box">
                                        <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                        </svg>
                                        <input v-model="pagFilter" type="text" class="modern-search-input" placeholder="Buscar por Nome">
                                    </div>
                                    <button type="button"
                                            class="search-filter-btn"
                                            :class="{ 'is-active': showFiltros || temFiltroAtivo }"
                                            :aria-expanded="showFiltros ? 'true' : 'false'"
                                            title="Filtros"
                                            @click="showFiltros = !showFiltros">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5z" />
                                        </svg>
                                        <span v-if="temFiltroAtivo" class="search-filter-badge"></span>
                                    </button>
                                </div>
                            </div>

                            <transition name="slide-filters">
                                <div v-if="showFiltros" class="list-filters-box bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                    <div class="filter-field">
                                        <label class="filter-label" for="filtroTipoProcesso">Tipo de Processo</label>
                                        <select id="filtroTipoProcesso"
                                                class="filter-select"
                                                v-model="filtroIdTipoProcesso">
                                            <option value="">Todos</option>
                                            <option v-for="proc in tiposProcessos" :key="proc.idTipoProcesso" :value="proc.idTipoProcesso">
                                                {{ proc.nmTipoProcesso }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="filter-field">
                                        <label class="filter-label" for="filtroLegislacao">Legislação</label>
                                        <select id="filtroLegislacao"
                                                class="filter-select"
                                                v-model="filtroIdLegislacao">
                                            <option value="">Todas</option>
                                            <option v-for="leg in legislacoes" :key="leg.idLegislacao" :value="leg.idLegislacao">
                                                {{ leg.dsNome }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="filter-field">
                                        <label class="filter-label" for="filtroAtivo">Ativo</label>
                                        <select id="filtroAtivo"
                                                class="filter-select"
                                                v-model="filtroFlFinalizado">
                                            <option value="">Todos</option>
                                            <option value="false">Ativos</option>
                                            <option value="true">Finalizados</option>
                                        </select>
                                    </div>
                                    <button type="button"
                                            class="filter-clear-btn"
                                            :disabled="!temFiltroAtivo"
                                            title="Limpar filtros"
                                            @click="limparFiltros">
                                        <i class="fas fa-times"></i>
                                        Limpar
                                    </button>
                                </div>
                            </transition>

                            <div class="list-grid-box">
                            <table class="custom-table bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                <!-- Header -->
                                <thead>
                                    <tr>
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">
                                            <div class="th-wrapper">
                                                <span class="th-title">Id</span>
                                                <button @click="ordenarPorColuna('tbGptProcessos.nrProcesso')"
                                                        class="btn btn-sort"
                                                        :class="{'text-primary': orderColumn === 'tbGptProcessos.nrProcesso',
                                                                'text-gray-300': orderColumn !== 'tbGptProcessos.nrProcesso'}">
                                                    <template v-if="orderColumn === 'tbGptProcessos.nrProcesso' && orderDirection === 'ASC'">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                                                        </svg>
                                                    </template>
                                                    <template v-else>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                        </svg>
                                                    </template>
                                                </button>
                                            </div>
                                        </th>
                                        <!-- Coluna Número -->
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">
                                            <div class="th-wrapper">
                                                <span class="th-title">Número</span>
                                                <button @click="ordenarPorColuna('tbGptProcessos.cdProcesso')"
                                                        class="btn btn-sort"
                                                        :class="{'text-primary': orderColumn === 'tbGptProcessos.cdProcesso',
                                                                 'text-gray-300': orderColumn !== 'tbGptProcessos.cdProcesso'}">
                                                    <template v-if="orderColumn === 'tbGptProcessos.cdProcesso' && orderDirection === 'ASC'">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                                                        </svg>
                                                    </template>
                                                    <template v-else>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                        </svg>
                                                    </template>
                                                </button>
                                            </div>
                                        </th>
                                        <!-- Coluna Tipo de Processo -->
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 10%;">
                                            <div class="th-wrapper">
                                                <span class="th-title">Tipo</span>
                                            </div>
                                        </th>
                                        <!-- Coluna Nome -->
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap;">
                                            <div class="th-wrapper left">
                                                <span class="th-title">Nome</span>
                                                <button @click="ordenarPorColuna('tbGptProcessos.dsNome')"
                                                        class="btn btn-sort-inline"
                                                        :class="{'text-primary': orderColumn === 'tbGptProcessos.dsNome',
                                                                'text-gray-300': orderColumn !== 'tbGptProcessos.dsNome'}">
                                                    <template v-if="orderColumn === 'tbGptProcessos.dsNome' && orderDirection === 'ASC'">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                                                        </svg>
                                                    </template>
                                                    <template v-else>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                        </svg>
                                                    </template>
                                                </button>
                                            </div>
                                        </th>
                                        <!-- Coluna Proprietário -->
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">
                                            <div class="th-wrapper">
                                                <span class="th-title">Proprietário</span>
                                                <button @click="ordenarPorColuna('tbGptProcessos.dsLogin')"
                                                        class="btn btn-sort"
                                                        :class="{'text-primary': orderColumn === 'tbGptProcessos.dsLogin',
                                                                'text-gray-300': orderColumn !== 'tbGptProcessos.dsLogin'}">
                                                    <template v-if="orderColumn === 'tbGptProcessos.dsLogin' && orderDirection === 'ASC'">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                                                        </svg>
                                                    </template>
                                                    <template v-else>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                        </svg>
                                                    </template>
                                                </button>
                                            </div>
                                        </th>
                                        <!-- Coluna Integrantes -->
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">
                                            <div class="th-wrapper">
                                                <span class="th-title">Integrantes</span>
                                                <button @click="ordenarPorColuna('tbGptProcessos.dsLogin')"
                                                        class="btn btn-sort d-none"
                                                        :class="{'text-primary': orderColumn === 'tbGptProcessos.dsLogin',
                                                                 'text-gray-300': orderColumn !== 'tbGptProcessos.dsLogin'}">
                                                    <template v-if="orderColumn === 'tbGptProcessos.dsLogin' && orderDirection === 'ASC'">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                                                        </svg>
                                                    </template>
                                                    <template v-else>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                        </svg>
                                                    </template>
                                                </button>
                                            </div>
                                        </th>
                                        <!-- Coluna Data de Inclusão -->
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">
                                            <div class="th-wrapper">
                                                <span class="th-title">Data de Inclusão</span>
                                                <button @click="ordenarPorColuna('tbGptProcessos.dtInclusao')"
                                                        class="btn btn-sort"
                                                        :class="{'text-gray-400': orderColumn !== 'tbGptProcessos.dtInclusao',
                                                                'text-primary': orderColumn === 'tbGptProcessos.dtInclusao'}">
                                                    <template v-if="orderColumn === 'tbGptProcessos.dtInclusao' && orderDirection === 'ASC'">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                                                        </svg>
                                                    </template>
                                                    <template v-else>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                        </svg>
                                                    </template>
                                                </button>
                                            </div>
                                        </th>
                                        <th scope="col" class="text-center bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">
                                            Status
                                        </th>
                                        <th scope="col" class="text-center bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100 actions-header" style="white-space: nowrap; width: 1%;">Ações</th>
                                    </tr>
                                </thead>
                                <!-- Body -->
                                <tbody>
                                    <tr v-for="(processo, index) in processos" :key="index">
                                        <td data-label="Id" class="text-center">
                                            <span class="id-badge">{{ processo.processo.nrProcesso }}</span>
                                        </td>
                                        <td data-label="Número" class="text-center">
                                            <span class="number-badge">{{ processo.processo.cdProcesso }}</span>
                                        </td>
                                        <td data-label="Tipo" class="text-center">
                                            <span class="process-name">{{ getNomeTipoProcesso(processo) }}</span>
                                        </td>
                                        <td data-label="Nome">
                                            <span class="process-name">{{ processo.processo.dsNome }}</span>
                                        </td>
                                        <td data-label="Proprietário" class="text-center">
                                            <div class="avatar-wrapper" data-bs-toggle="popover" data-bs-placement="top" :data-bs-content="getDataBsProprietario(processo.proprietario)">
                                                <div class="modern-avatar" :style="processo.proprietario.urlImgFoto ? '' : 'background:#' + intToRGB(hashCode(processo.proprietario.nmUsuario))">
                                                    <img v-if="processo.proprietario.urlImgFoto" :src="processo.proprietario.urlImgFoto" alt="" />
                                                    <span v-else class="avatar-initials">{{ processo.proprietario.nmUsuario.slice(0,2) }}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td data-label="Integrantes" class="text-center">
                                            <div class="avatars-group">
                                                <div class="modern-avatar avatar-small"
                                                     v-for="(integrante,index2) in processo.integrantes"
                                                     :key="index2"
                                                     :style="integrante.usuario ? ( integrante.usuario?.urlImgFoto ?
                                                                    '' : 'background:#' + intToRGB(hashCode(integrante.usuario?.nmUsuario))
                                                            ) : ( integrante.setor ? 'background:#' + intToRGB(hashCode(integrante.setor?.nmSetor)):'' ) "
                                                     data-bs-toggle="popover"
                                                     data-bs-placement="top"
                                                     :data-bs-content="getDataBs(integrante)">
                                                    <img v-if="integrante.usuario?.urlImgFoto" :src="integrante.usuario?.urlImgFoto" alt="">
                                                    <span v-else-if="integrante.usuario" class="avatar-initials">{{ integrante.usuario.nmUsuario.slice(0,2) }}</span>
                                                    <span v-else class="avatar-initials">{{ integrante.setor.cdSetor.slice(0,2) }}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td data-label="Data de Inclusão" class="text-center">{{ formatarData(processo.processo.dtInclusao) }}</td>
                                        <td data-label="Status" class="text-center">
                                            <template v-if="processo.processo.flFinalizado">
                                                <span class="number-badge">Finalizado</span>
                                            </template>
                                            <template v-else>
                                                <span class="number-badge">Ativo</span>
                                            </template>
                                        </td>
                                        <td data-label="Ações" class="text-center action-cell">
                                            <div class="action-buttons">
                                                <button @click="abrirDetalhes(processo)"
                                                        class="action-btn action-btn-view"
                                                        title="Ver Detalhes">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                                    </svg>
                                                    <span class="action-text">Detalhes</span>
                                                </button>
                                                <div class="dropdown action-dropdown"
                                                     v-if="podeExibirMenuAcoes(processo)"
                                                     data-bs-popper-config='{"strategy":"fixed"}'>
                                                    <button class="action-btn action-btn-more dropdown-toggle"
                                                            type="button"
                                                            data-bs-toggle="dropdown"
                                                            data-bs-auto-close="true"
                                                            aria-expanded="false"
                                                            title="Mais opções">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                                            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                                        </svg>
                                                    </button>
                                                    <div class="dropdown-menu dropdown-menu-end action-dropdown-menu">
                                                        <button v-if="podeDuplicarProcesso(processo)"
                                                                type="button"
                                                                class="action-dropdown-item"
                                                                @click="historicoProcesso(processo)">
                                                            
                                                            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M3 5.67541V3C3 2.44772 2.55228 2 2 2C1.44772 2 1 2.44772 1 3V7C1 8.10457 1.89543 9 3 9H7C7.55229 9 8 8.55229 8 8C8 7.44772 7.55229 7 7 7H4.52186C4.54218 6.97505 4.56157 6.94914 4.57995 6.92229C5.621 5.40094 7.11009 4.22911 8.85191 3.57803C10.9074 2.80968 13.173 2.8196 15.2217 3.6059C17.2704 4.3922 18.9608 5.90061 19.9745 7.8469C20.9881 9.79319 21.2549 12.043 20.7247 14.1724C20.1945 16.3018 18.9039 18.1638 17.0959 19.4075C15.288 20.6513 13.0876 21.1909 10.9094 20.9247C8.73119 20.6586 6.72551 19.605 5.27028 17.9625C4.03713 16.5706 3.27139 14.8374 3.06527 13.0055C3.00352 12.4566 2.55674 12.0079 2.00446 12.0084C1.45217 12.0088 0.995668 12.4579 1.04626 13.0078C1.25994 15.3309 2.2082 17.5356 3.76666 19.2946C5.54703 21.3041 8.00084 22.5931 10.6657 22.9188C13.3306 23.2444 16.0226 22.5842 18.2345 21.0626C20.4464 19.541 22.0254 17.263 22.6741 14.6578C23.3228 12.0526 22.9963 9.30013 21.7562 6.91897C20.5161 4.53782 18.448 2.69239 15.9415 1.73041C13.4351 0.768419 10.6633 0.756291 8.14853 1.69631C6.06062 2.47676 4.26953 3.86881 3 5.67541Z" fill="#0F0F0F"></path> <path d="M12 5C11.4477 5 11 5.44771 11 6V12.4667C11 12.4667 11 12.7274 11.1267 12.9235C11.2115 13.0898 11.3437 13.2344 11.5174 13.3346L16.1372 16.0019C16.6155 16.278 17.2271 16.1141 17.5032 15.6358C17.7793 15.1575 17.6155 14.546 17.1372 14.2698L13 11.8812V6C13 5.44772 12.5523 5 12 5Z" fill="#0F0F0F"></path> </g></svg>
                                                            <span>Histórico</span>
                                                        </button>
                                                        <button v-if="podeDuplicarProcesso(processo)"
                                                                type="button"
                                                                class="action-dropdown-item"
                                                                @click="duplicarProcesso(processo)">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                <path d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z" />
                                                            </svg>
                                                            <span>Duplicar</span>
                                                        </button>
                                                        <button v-if="podeExcluirProcesso(processo)"
                                                                type="button"
                                                                class="action-dropdown-item action-dropdown-item-delete"
                                                                @click="deletarProcesso(processo.processo.idProcesso)">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                            </svg>
                                                            <span>Excluir</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="processos.length === 0 && !loadingProcessos">
                                        <td colspan="9" class="empty-state">
                                            <div class="empty-content">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                                </svg>
                                                <h3 class="empty-title">Nenhum processo encontrado</h3>
                                                <p class="empty-description">Crie seu primeiro processo inteligente para começar</p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="custom-table-footer bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100 flex justify-between items-center">
                                <div class="pagination-controls flex items-center">
                                    <span @click="previousPage"
                                          :class="['page-box', { 'disabled': currentPage === 0 }]">
                                        <span class="navigation-symbol">«</span>
                                    </span>
                                    <span v-for="page in pagesToShow"
                                          :key="page"
                                          @click="goToPage(page)"
                                          :class="['page-box',page === currentPage ? 'btn btn-primary-soft' : '']">
                                        {{ page + 1 }}
                                    </span>

                                    <span @click="nextPage"
                                          :class="['page-box', { 'disabled': !temProximaPagina }]">
                                        <span class="navigation-symbol">»</span>
                                    </span>
                                </div> <!-- pagination-controll -->
                                <span class="text-sm font-semibold text-gray-600">Registros encontrados: {{ qtdRegistros }}</span>
                            </div> <!-- custom-table-footer -->
                            </div><!-- list-grid-box -->
                        </div><!-- table-wrapper -->
                    </div><!-- table-container -->
                </div><!-- tyn-section -->
            </div><!-- tyn-main -->
        </div><!-- tyn-content -->
        <!-- MODAIS HEADER -->
        <Modais></Modais>
        <!-- MODAL NOVO PROCESSO -->
        <div class="modal fade modern-modal" id="ModalProcessoInclusao" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg modal-modern">
                <div class="modal-content modal-modern-content border-0">
                    <button type="button" class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                            data-bs-dismiss="modal" aria-label="Close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none">
                                <path d="M12 4V20M4 12H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2>Novo Processo</h2>
                            <p>Complete os campos para cadastrar um novo Processo Inteligente.</p>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <div class="form-grid form-grid-3">
                            <div class="form-group">
                                <label class="form-label">Número do Processo</label>
                                <input type="text" class="form-control"
                                       v-model="cdProcessoNumero"
                                       :class="{ 'border-danger': camposInvalidos.cdProcessoNumero }"
                                       placeholder="Digite o número do processo" maxlength="50" />
                            </div>
                            <div class="form-group">
                                <label class="form-label">Legislação</label>
                                <select class="form-control"
                                        v-model="legislacaoSelecionadaId"
                                        :class="{ 'border-danger': camposInvalidos.legislacaoSelecionadaId }">
                                    <option disabled value="">Selecione uma Legislação</option>
                                    <option v-for="leg in legislacoes" :key="leg.idLegislacao" :value="leg.idLegislacao">
                                        {{ leg.dsNome }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Tipo de Processo</label>
                                <select class="form-control"
                                        v-model="ProcessoSelecionadoId"
                                        :class="{ 'border-danger': camposInvalidos.ProcessoSelecionadoId }">
                                    <option disabled value="">Selecione um Tipo</option>
                                    <option v-for="proc in tiposProcessos" :key="proc.idTipoProcesso" :value="proc.idTipoProcesso">
                                        {{ proc.nmTipoProcesso }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <SelectWorkflowProcesso ref="workflowInclusao"
                                                v-model="idProcessoWorkflowSelecionado"
                                                select-id="workflowProcessoInclusao"
                                                :id-legislacao="legislacaoSelecionadaId"
                                                :id-tipo-processo="ProcessoSelecionadoId"
                                                @state="atualizarEstadoWorkflow" />

                        <div class="form-grid form-grid-2">
                            <div class="form-group">
                                <label class="form-label">Nome do Processo</label>
                                <input type="text" class="form-control"
                                       v-model="dsNomeProcesso"
                                       :class="{ 'border-danger': camposInvalidos.dsNomeProcesso }"
                                       placeholder="Digite o nome do processo" maxlength="200" />
                            </div>
                            <div class="form-group">
                                <label class="form-label">Lote Único</label>
                                <select class="form-control"
                                        v-model="flLoteUnico"
                                        :class="{ 'border-danger': camposInvalidos.flLoteUnico }">
                                    <option disabled value="">Selecione:</option>
                                    <option :value="true">Sim</option>
                                    <option :value="false">Não</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Descrição do Processo</label>
                            <textarea class="form-control form-textarea"
                                      v-model="dsProcesso"
                                      placeholder="Caso queira, descreva detalhes adicionais"
                                      maxlength="500"
                                      rows="3"></textarea>
                            <small class="text-muted">Máximo de 500 caracteres.</small>
                        </div>

                        <div v-if="hasMatchingWorkflow" class="form-grid form-grid-2">
                            <div>
                                <label class="form-label">Data de início</label>
                                <input type="date" class="form-control"
                                       v-model="dtInicio"
                                       :class="{ 'border-danger': camposInvalidos.dtInicio }" />

                                <div class="form-grid form-group-inline mt-2">

                                    <div class="info-chip w-100">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 .876-.252 1.02-.598l.088-.416c.066-.3.104-.378.288-.41l.451-.083.082-.38-1.428-.287.545-2.545z" />
                                            <circle cx="8" cy="4.5" r="1" />
                                        </svg>
                                        Os prazos definidos no fluxo serão contabilizados a partir desta data.
                                    </div>
                                </div>
                            </div>
                            <div>
                                <label class="form-label">Data estimada de finalização</label>
                                <input type="date" class="form-control"
                                       v-model="dtFinalizacaoEstimada" />
                            </div>


                        </div>
                        

                    </div>

                    <div class="modal-modern-footer">
                        <button type="button"
                                class="btn btn-primary btn-modern-primary w-100"
                                :disabled="workflowCarregando"
                                @click="salvarProcesso">
                            Salvar Processo
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <ProcessoCalendario ref="processoCalendario" :legislacoes="legislacoes" :tipos-processos="tiposProcessos" />
        <ModalProcessoProgressao :FiltroEtapa="filtroProgressao" ref="modalProgressao" />
        <ModalCriarProcessoPorRegistro ref="modalCriarPorRegistro"
                                       :legislacoes="legislacoes"
                                       :tipos-processos="tiposProcessos"
                                       :idProcesso="idProcessoElaboracao"
                                       @saved="onProcessoCriadoPorRegistro"
                                       @refreshGrid="getProcessos"
                                       />
        <ModalCriarProcessoERegistro ref="modalCriarProcessoERegistro"
                                     :legislacoes="legislacoes"
                                     :tipos-processos="tiposProcessos"
                                     @saved="onProcessoCriadoProcessoERegistro" />

        <ModalProcessoHistorico ref="modalProcessoHistorico" :idProcesso="idProcessoHistorico"/>
    </div> <!-- tyn-root-->
</template>
<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import axios from 'axios'
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import Swal from 'sweetalert2'
    import ProcessoCalendario from '@/views/ProcessoCalendario.vue'
    import ModalProcessoProgressao from '@/components/ProcessoInteligente/ModalProcessoProgressao.vue'
    import ModalCriarProcessoPorRegistro from '@/components/ProcessoInteligente/ModalCriaProcessoPorRegistro.vue'
    import ModalCriarProcessoERegistro from '@/components/ProcessoInteligente/ModalCriaProcessoERegistro.vue'
    import SelectWorkflowProcesso from '@/components/ProcessoInteligente/SelectWorkflowProcesso.vue'
    import ModalProcessoHistorico from '@/components/ProcessoInteligente/ModalProcessoHistorico.vue'

    export default {
        name: 'ProcessosInteligentes',
        components: { Header, Modais, ProcessoCalendario, ModalProcessoProgressao, ModalCriarProcessoPorRegistro, ModalCriarProcessoERegistro, SelectWorkflowProcesso, ModalProcessoHistorico },
        data: function () {
            return {
                pagFilter: '',
                processos: [],
                legislacoes: [],
                qtdRegistros: 0,
                legislacaoSelecionadaId: '',
                ProcessoSelecionadoId: '',
                flLoteUnico: '',
                tiposProcessos: [],
                dsNomeProcesso: '',
                cdProcessoNumero: '',
                dsProcesso: '',
                currentPage: 0,
                pageSize: 6,
                debounceTimeout: null,
                orderColumn: 'tbGptProcessos.nrProcesso',
                orderDirection: 'DESC',
                camposInvalidos: {
                    dsNomeProcesso: false,
                    legislacaoSelecionadaId: false,
                    flLoteUnico: false,
                    ProcessoSelecionadoId: false,
                    cdProcessoNumero: false,
                    dtInicio: false
                },
                nomeUsuario: '',
                dtInicio: '',
                dtFinalizacaoEstimada: '',
                utilizacoes: null,
                percentual: 0,
                txtPercentual: "",
                idProcessoWorkflowSelecionado: null,
                workflowCarregando: false,
                possuiWorkflows: false,
                filtroProgressao: 'TODOS',
                controllerGetProcessos: null,
                showCreateMenu: false,
                showFiltros: false,
                filtroIdTipoProcesso: '',
                filtroFlFinalizado: '',
                filtroIdLegislacao: '',
                limpandoFiltros: false,

                // idProcesso modal a partir de registro
                idProcessoElaboracao: 0,
                loadingProcessos: false,

                idProcessoHistorico: 0,
            }
        },
        watch: {
            pagFilter: {
                handler() {
                    clearTimeout(this.debounceTimeout);
                    this.debounceTimeout = setTimeout(() => {
                        this.currentPage = 0;
                        this.getProcessos();
                    }, 500);
                }
            },
            legislacaoSelecionadaId() { this.handleWorkflowToggle(); },
            ProcessoSelecionadoId() { this.handleWorkflowToggle(); },
            filtroIdTipoProcesso() {
                if (this.limpandoFiltros) return;
                this.currentPage = 0;
                this.getProcessos();
            },
            filtroFlFinalizado() {
                if (this.limpandoFiltros) return;
                this.currentPage = 0;
                this.getProcessos();
            },
            filtroIdLegislacao() {
                if (this.limpandoFiltros) return;
                this.currentPage = 0;
                this.getProcessos();
            },
        },

        methods: {
            load() {
                this.getProcessos();
                this.getLegislacoes();
                this.getProcessosTipo();
                this.carregaUtilizacoes();
            },

            limparFiltros() {
                if (!this.temFiltroAtivo) return;

                this.limpandoFiltros = true;
                this.filtroIdTipoProcesso = '';
                this.filtroFlFinalizado = '';
                this.filtroIdLegislacao = '';
                this.limpandoFiltros = false;
                this.currentPage = 0;
                this.getProcessos();
            },

            getProcessos() {
                let $this = this;
                const orderBy = $this.orderColumn
                    ? `${$this.orderColumn} ${$this.orderDirection}`
                    : null;
                this.loadingProcessos = true;
                axios.get(`${urlApi}/Processo/Get`, {
                    params: {
                        index: $this.currentPage,
                        take: $this.pageSize,
                        dsTermo: $this.pagFilter,
                        orderBy: orderBy,
                        idTipoProcesso: $this.filtroIdTipoProcesso || null,
                        flFinalizado: $this.filtroFlFinalizado === '' ? null : $this.filtroFlFinalizado === 'true',
                        idLegislacao: $this.filtroIdLegislacao || null
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            $this.processos = result.resultados.rows.map(p => ({
                                ...p,
                            }));
                            $this.qtdRegistros = result.resultados.qtdRecords;
                            $this.montaPopover();
                        } else {
                            console.warn("Resposta sem sucesso");
                        }
                        $this.loadingProcessos = false;
                    })
                    .catch(err => {
                        console.error("Erro ao fazer requisição:", err);
                        avisoToast("Erro ao carregar processos!", "warning");
                        $this.loadingProcessos = false;
                    });
            },

            ordenarPorColuna(coluna) {
                if (this.orderColumn === coluna) {
                    this.orderDirection = this.orderDirection === 'ASC' ? 'DESC' : 'ASC';
                } else {
                    this.orderColumn = coluna;
                    this.orderDirection = 'ASC';
                }
                this.getProcessos();
            },

            getLegislacoes() {
                let $this = this;
                axios.get(`${urlApi}/Legislacao/GetLegislacoesProduto/`, { showLoading: false, params: { cdIdentificador: 'PI' } })
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.legislacoes = result;
                        } else {
                            console.warn("Resposta sem sucesso");
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao fazer requisição:", err);
                        if (err.response && err.response.data) {
                            avisoErro(err.response.data);
                            avisoToast("Erro ao carregar Legislações!", "warning");
                        } else {
                            avisoErro(err.message || "Erro desconhecido");
                        }
                        $this.loading.hide();
                    });
            },

            getProcessosTipo() {
                let $this = this;
                axios.get(`${urlApi}/TipoProcesso/Get`)
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.tiposProcessos = result;
                        } else {
                            console.warn("Resposta sem sucesso");
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao fazer requisição:", err);
                        if (err.response && err.response.data) {
                            avisoErro(err.response.data);
                            avisoToast("Erro ao carregar processos!", "warning");
                        } else {
                            avisoErro(err.message || "Erro desconhecido");
                        }
                        $this.loading.hide();
                    });
            },

            abrirDashboard() {
                this.$router.push({ name: 'DashboardProcesso' });
            },

            abrirCalendario() {
                if (this.$refs.processoCalendario?.abrir) {
                    this.$refs.processoCalendario.abrir();
                    return;
                }
                const modal = new window.bootstrap.Modal('#ModalProcessoCalendario');
                modal.show();
            },

            abrirModalProgressao(tipo) {
                this.filtroProgressao = tipo
                if (this.$refs.modalProgressao?.abrir) {
                    this.$refs.modalProgressao.abrir(tipo)
                } else {
                    const modal = new window.bootstrap.Modal('#ModalProcessoProgressao', { focus: false })
                    modal.show()
                }
            },

            abrirModalInclusao() {
                const el = document.getElementById('ModalProcessoInclusao');
                if (!el) return;

                const bs = window.bootstrap || window.Bootstrap || null;
                if (bs && bs.Modal) {
                    const modal = new bs.Modal(el);
                    modal.show();
                } else if (window.$ && typeof window.$.fn.modal === 'function') {
                    window.$(el).modal({ backdrop: 'static', keyboard: false, show: true });
                }

                this.handleWorkflowToggle();
                this.$refs.workflowInclusao?.recarregar();
            },

            handleWorkflowToggle() {
                if (!this.hasMatchingWorkflow) {
                    this.dtInicio = '';
                    this.camposInvalidos.dtInicio = false;
                }
            },

            atualizarEstadoWorkflow(estado) {
                this.workflowCarregando = estado.loading === true;
                this.possuiWorkflows = estado.hasWorkflows === true;
                this.handleWorkflowToggle();
            },

            async salvarProcesso() {
                if (this.workflowCarregando) {
                    avisoToast('Aguarde o carregamento dos workflows.', 'warning');
                    return;
                }
                this.camposInvalidos.dsNomeProcesso = !this.dsNomeProcesso?.trim();
                this.camposInvalidos.legislacaoSelecionadaId = !this.legislacaoSelecionadaId;
                this.camposInvalidos.ProcessoSelecionadoId = !this.ProcessoSelecionadoId;
                this.camposInvalidos.cdProcessoNumero = !this.cdProcessoNumero?.trim();
                this.camposInvalidos.flLoteUnico = this.flLoteUnico !== true && this.flLoteUnico !== false;
                this.camposInvalidos.dtInicio = this.hasMatchingWorkflow && !this.dtInicio;
                const workflowInvalido = this.possuiWorkflows && !this.idProcessoWorkflowSelecionado;

                const invalido = Object.values(this.camposInvalidos).some(c => c) || workflowInvalido;
                if (invalido) {
                    avisoErro("Preencha todos os campos obrigatórios.");
                    return;
                }

                const payload = {
                    idLegislacao: parseInt(this.legislacaoSelecionadaId),
                    idTipoProcesso: parseInt(this.ProcessoSelecionadoId),
                    idProcessoWorkflow: this.idProcessoWorkflowSelecionado,
                    flLoteUnico: this.flLoteUnico,
                    dsNome: this.dsNomeProcesso,
                    dsProcesso: this.dsProcesso,
                    cdProcesso: this.cdProcessoNumero,
                    dtInicio: this.hasMatchingWorkflow ? this.dtInicio : null,
                    dtFinalizacaoEstimada: this.dtFinalizacaoEstimada || null,

                };

                try {
                    const res = await axios.post(`${urlApi}/Processo/Post`, payload);

                    if (!res.data?.success) {
                        const erroMsg = res.data?.msg || "Erro ao salvar processo!";
                        avisoErro(erroMsg);
                        avisoToast(erroMsg, "warning");
                        return;
                    }
                    const novoId =
                        res.data?.data ??
                        (() => {
                            const loc = res.headers?.location;
                            const m = loc ? /\/(\d+)$/.exec(loc) : null;
                            return m ? Number(m[1]) : null;
                        })();

                    avisoToast("Processo criado com sucesso!", "success");

                    this.getProcessos();
                    this.fecharModalInclusao();
                    this.mostrarModalInclusao = false;
                    this.legislacaoSelecionadaId = '';
                    this.ProcessoSelecionadoId = '';
                    this.idProcessoWorkflowSelecionado = null;
                    this.flLoteUnico = null;
                    this.dsNomeProcesso = '';
                    this.dsProcesso = '';
                    this.cdProcessoNumero = '';
                    this.dtInicio = '';
                    this.dtFinalizacaoEstimada = '';

                    if (novoId) {
                        this.$nextTick(() => this.$router.push({ name: 'DetalhesProcesso', params: { id: novoId } }));
                    } else {
                        console.warn('ID do processo não encontrado.');
                    }

                } catch (err) {
                    if (err.response?.data) {
                        const response = err.response.data;
                        const mensagem = response.msg || "Erro ao salvar processo!";
                        const motivo = response.errors?.[0];

                        if (mensagem === "Limite de utilizações") {
                            avisoErro(mensagem + '. ' + motivo);
                        } else {
                            avisoErro(mensagem);
                        }
                    } else {
                        avisoErro(err.message || "Erro desconhecido");
                    }
                }
            },

            getNomeTipoProcesso(item) {
                const idTipoProcesso = item?.configuracoes?.idTipoProcesso;
                if (!idTipoProcesso) return '-';

                const tipo = (this.tiposProcessos || []).find(proc => Number(proc.idTipoProcesso) === Number(idTipoProcesso));
                return tipo?.nmTipoProcesso || '-';
            },

            previousPage() {
                if (this.currentPage > 0) {
                    this.currentPage--;
                    this.getProcessos();
                }
            },

            nextPage() {
                if (this.temProximaPagina) {
                    this.currentPage++;
                    this.getProcessos();
                }
            },

            goToPage(pageIndex) {
                if (pageIndex !== this.currentPage) {
                    this.currentPage = pageIndex;
                    this.getProcessos();
                }
            },

            podeDuplicarProcesso(processo) {
                return processo?.configuracoes?.cdTipoCadastro === 'PD';
            },

            podeExcluirProcesso(processo) {
                return processo.proprietario.dsLogin == this.user.usuario.dsLogin || this.podeGerenciarProcessos;
            },

            podeExibirMenuAcoes(processo) {
                return this.podeDuplicarProcesso(processo) || this.podeExcluirProcesso(processo);
            },

            historicoProcesso(processo) {
                this.idProcessoHistorico = processo.processo.idProcesso;
                if (this.$refs.modalProcessoHistorico?.abrir) {
                    axios.post(`${urlApi}/Log/Registrar`, { cdTipoLog:'PI_ACS_HIST_PROC' }).catch(() => { })
                    this.$refs.modalProcessoHistorico.abrir(processo.processo.idProcesso);
                }
            },

            duplicarProcesso(processo) {
                const nomePadrao = processo.processo.dsNome || '';
                const numeroPadrao = processo.processo.cdProcesso || '';

                Swal.fire({
                    title: 'Duplicar processo?',
                    html: `
                        <p style="margin-bottom: 16px; color: #64748b; text-align: left; font-size: 14px;">
                            Será criada uma cópia do processo. Você pode manter ou alterar o nome e o número.
                        </p>
                        <div style="text-align: left;">
                            <label for="swal-dup-nome" style="display: block; font-weight: 600; margin-bottom: 4px; font-size: 13px;">Nome do Processo</label>
                            <input id="swal-dup-nome" class="swal2-input" style="margin: 0 0 12px 0; width: 100%; box-sizing: border-box;" maxlength="200" placeholder="Digite o nome do processo">
                            <label for="swal-dup-numero" style="display: block; font-weight: 600; margin-bottom: 4px; font-size: 13px;">Número do Processo</label>
                            <input id="swal-dup-numero" class="swal2-input" style="margin: 0; width: 100%; box-sizing: border-box;" maxlength="50" placeholder="Digite o número do processo">
                        </div>
                    `,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#6c757d',
                    confirmButtonText: 'Duplicar',
                    cancelButtonText: 'Cancelar',
                    focusConfirm: false,
                    didOpen: () => {
                        const nomeInput = document.getElementById('swal-dup-nome');
                        const numeroInput = document.getElementById('swal-dup-numero');
                        if (nomeInput) nomeInput.value = nomePadrao;
                        if (numeroInput) numeroInput.value = numeroPadrao;
                        if (nomeInput) nomeInput.focus();
                    },
                    preConfirm: () => {
                        const dsNome = document.getElementById('swal-dup-nome')?.value?.trim();
                        const cdProcesso = document.getElementById('swal-dup-numero')?.value?.trim();

                        if (!dsNome) {
                            Swal.showValidationMessage('Informe o nome do processo.');
                            return false;
                        }

                        if (!cdProcesso) {
                            Swal.showValidationMessage('Informe o número do processo.');
                            return false;
                        }

                        return { dsNome, cdProcesso };
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        const { dsNome, cdProcesso } = result.value;
                        axios.post(`${urlApi}/Processo/Duplicar`, {
                            idProcesso: processo.processo.idProcesso,
                            dsNome,
                            cdProcesso
                        })
                            .then(res => {
                                if (res.data.success) {
                                    avisoToast("Processo duplicado com sucesso!", "success");
                                    this.getProcessos();
                                    this.carregaUtilizacoes();
                                    const idProcesso = res.data.data;
                                    if (idProcesso) {
                                        this.$router.push({
                                            name: 'DetalhesProcesso',
                                            params: { id: idProcesso }
                                        });
                                    }
                                } else {
                                    const erroMsg = res.data.msg || "Erro ao duplicar processo!";
                                    avisoErro(erroMsg);
                                    avisoToast(erroMsg, "warning");
                                }
                            })
                            .catch(err => {
                                console.error("Erro ao duplicar processo:", err);
                                if (err.response?.data) {
                                    const response = err.response.data;
                                    const erroMsg = response.errors?.[0] || response.msg || "Erro ao duplicar processo!";
                                    avisoErro(erroMsg);
                                    avisoToast(erroMsg, "warning");
                                } else {
                                    avisoErro(err.message || "Erro desconhecido");
                                }
                            });
                    }
                });
            },

            deletarProcesso(idProcesso) {
                Swal.fire({
                    title: 'Tem certeza?',
                    text: 'Essa ação não poderá ser desfeita!',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Sim, excluir!',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.delete(`${urlApi}/Processo/Delete`, {
                            params: { id: idProcesso }
                        })
                            .then(res => {
                                if (res.data.success) {
                                    avisoToast("Processo excluído com sucesso!", "success");
                                    this.getProcessos();
                                } else {
                                    const erroMsg = res.data.msg || "Erro ao excluir processo!";
                                    avisoErro(erroMsg);
                                    avisoToast(erroMsg, "warning");
                                }
                            })
                            .catch(err => {
                                console.error("Erro ao excluir processo:", err);
                                if (err.response && err.response.data) {
                                    avisoErro(err.response.data);
                                    avisoToast("Erro ao excluir processo!", "warning");
                                } else {
                                    avisoErro(err.message || "Erro desconhecido");
                                }
                            });
                    }
                });
            },

            toggleCreateMenu() {
                this.showCreateMenu = !this.showCreateMenu;
            },

            closeCreateMenu() {
                this.showCreateMenu = false;
            },

            onCreateFromScratch() {
                this.closeCreateMenu();
                this.abrirModalInclusao();
            },

            onCreateFromNecessidade() {
                this.closeCreateMenu();
                this.idProcessoElaboracao = 0;
                this.$nextTick(() => {
                    if (this.$refs.modalCriarPorRegistro?.abrir) {
                        this.$refs.modalCriarPorRegistro.abrir();
                        return;
                    }

                    const el = document.getElementById('ModalCriarProcessoPorRegistro');
                    const bs = window.bootstrap || window.Bootstrap;
                    if (el && bs?.Modal) new bs.Modal(el, { focus: false }).show();
                });
                
            },

            onProcessoCriadoPorRegistro(idProcesso) {
                if (!idProcesso) {
                    console.warn('ID do processo não retornado.');
                    return;
                }

                this.getProcessos();
                this.$nextTick(() => {
                    this.$router.push({
                        name: 'DetalhesProcesso',
                        params: { id: idProcesso }
                    });
                });
            },

            onCreateProcessAndNecessidade() {
                this.closeCreateMenu();

                if (this.$refs.modalCriarProcessoERegistro?.abrir) {
                    this.$refs.modalCriarProcessoERegistro.abrir();
                    return;
                }

                const el = document.getElementById('ModalCriarProcessoERegistro');
                const bs = window.bootstrap || window.Bootstrap;
                if (el && bs?.Modal) new bs.Modal(el, { focus: false }).show();
            },

            onProcessoCriadoProcessoERegistro(idProcesso) {
                if (!idProcesso) {
                    console.warn('ID do processo não retornado.');
                    return;
                }

                this.getProcessos();
                this.$nextTick(() => {
                    this.$router.push({
                        name: 'DetalhesProcesso',
                        params: { id: idProcesso }
                    });
                });
            },

            handleOutsideClickCreateMenu(e) {
                if (!this.showCreateMenu) return;
                const root = this.$el && this.$el.querySelector('.create-dropdown');
                if (!root) return;
                if (!root.contains(e.target)) this.closeCreateMenu();
            },

            abrirDetalhes(processo) {
                // verifica se eh elaboracao
                if (processo.processo.flAguardando && processo.configuracoes.cdTipoCadastro == 'AR') {
                    this.idProcessoElaboracao = processo.processo.idProcesso;
                    this.$nextTick(function () {
                        this.$refs.modalCriarPorRegistro.abrir();
                    });
                    
                    return;
                } else {
                    this.$router.push({ name: 'DetalhesProcesso', params: { id: processo.processo.idProcesso } });
                }                
            },

            abrirStatusArtefatos() {
                this.$router.push({ name: 'ArtefatosGeraisStatus' });
            },

            formatarData(dataISO) {
                if (!dataISO) return '';
                const data = new Date(dataISO);
                return data.toLocaleDateString('pt-BR');
            },

            hashCode(str) {
                if (!str) return 0;
                var hash = 0;
                for (var i = 0; i < str.length; i++) {
                    hash = str.charCodeAt(i) + ((hash << 5) - hash);
                }
                return hash;
            },

            intToRGB(i) {
                var c = (i & 0x00FFFFFF)
                    .toString(16)
                    .toUpperCase();
                return "00000".substring(0, 6 - c.length) + c;
            },
            getDataBsProprietario(item) {
                return ` <span class="mb-0">${item.nmUsuario}</span> `;
            },
            getDataBs(item) {
                if (item.usuario) {
                    return ` <span class="mb-0">${item.usuario.nmUsuario}</span> `;
                } else {
                    return ` <span class="mb-0">${item.setor.nmSetor}</span> `;
                }
            },
            montaPopover() {
                var popovers = document.querySelectorAll(".popover");
                // Itera sobre cada elemento e remove-o
                popovers.forEach(function (popover) {
                    popover.remove();
                });

                this.$nextTick(function () {
                    var popoverTriggerList = document.querySelectorAll(
                        '[data-bs-toggle="popover"]',
                    );// eslint-disable-line no-console

                    if (popoverTriggerList.length > 0) {
                        [].slice
                            .call(popoverTriggerList)
                            .map(function (popoverTriggerEl) {
                                return new window.bootstrap.Popover(popoverTriggerEl, {
                                    trigger: "hover",
                                    boundary: "window",
                                    html: true,
                                    customClass: 'custom-popover'
                                    //placement: "right",
                                });
                            });
                    }
                });
            },

            carregaUtilizacoes() {
                let $this = this;
                axios.get(`${urlApi}/Processo/Utilizacoes`, { showLoading: false })
                    .then(res => {
                        if (res.data.success) {
                            $this.utilizacoes = res.data.data;
                            if ($this.utilizacoes.qtdLiberados != 'Ilimitado') {
                                try {
                                    this.percentual = parseInt(parseInt($this.utilizacoes.qtdRealizados) * 100 / parseInt($this.utilizacoes.qtdLiberados));
                                    this.txtPercentual = this.percentual + "%";
                                } catch {
                                    avisoErro("Não foi possível carregar a quantidade de processos.");
                                }
                            } else {
                                this.percentual = 100;
                                this.txtPercentual = "Ilimitado";
                            }
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de processos.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        }
                    });
            },

            fecharModalInclusao() {
                const el = document.getElementById('ModalProcessoInclusao');
                if (!el) return;

                const bs = window.bootstrap || window.Bootstrap || null;

                if (bs && bs.Modal) {
                    const modalInstance = bs.Modal.getInstance(el);
                    if (modalInstance) {
                        modalInstance.hide();
                    }
                } else if (window.$ && typeof window.$.fn.modal === 'function') {
                    window.$(el).modal('hide');
                }
            }

        },

        mounted: function () {
            this.load();
            document.addEventListener('click', this.handleOutsideClickCreateMenu);
        },
        beforeDestroy() {
            document.removeEventListener('click', this.handleOutsideClickCreateMenu);
        },

        computed: {
            totalPages() {
                return Math.ceil(this.qtdRegistros / this.pageSize);
            },
            temFiltroAtivo() {
                return (this.filtroIdTipoProcesso !== '' && this.filtroIdTipoProcesso !== null && this.filtroIdTipoProcesso !== undefined)
                    || (this.filtroFlFinalizado !== '' && this.filtroFlFinalizado !== null && this.filtroFlFinalizado !== undefined)
                    || (this.filtroIdLegislacao !== '' && this.filtroIdLegislacao !== null && this.filtroIdLegislacao !== undefined);
            },
            temProximaPagina() {
                return (this.currentPage + 1) < this.totalPages;
            },
            pagesToShow() {
                const maxPages = 5;
                const pages = [];

                let start = Math.max(this.currentPage - 2, 0);
                let end = Math.min(start + maxPages, this.totalPages);

                if (end - start < maxPages) {
                    start = Math.max(end - maxPages, 0);
                }

                for (let i = start; i < end; i++) {
                    pages.push(i);
                }

                return pages;
            },
            user() {
                return this.$store.state.user
            },
            isAdmContrato() {
                return this.$store.state.isAdmContrato === 'Sim';
            },
            isAdmin() {
                return this.$store.state.isAdmin === 'Sim';
            },
            podeGerenciarProcessos() {
                return this.isAdmContrato || this.isAdmin;
            },
            hasMatchingWorkflow() {
                return this.possuiWorkflows;
            },

        }

    };
</script>
<style lang="css" scoped>

    .create-dropdown {
        position: relative;
        display: inline-block;
        flex-shrink: 0;
    }

    .create-dropdown__toggle {
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }

    .create-dropdown__menu {
        position: absolute;
        top: calc(100% + 10px);
        left: 0;
        width: 360px;
        max-width: calc(100vw - 24px);
        background: #fff;
        border: 1px solid rgba(0,0,0,.08);
        border-radius: 14px;
        box-shadow: 0 12px 32px rgba(0,0,0,.12);
        padding: 10px;
        z-index: 1050;
    }

    .create-dropdown__header {
        padding: 10px 10px 12px 10px;
        border-bottom: 1px solid rgba(0,0,0,.06);
        margin-bottom: 8px;
    }

    .create-dropdown__title {
        font-weight: 700;
        font-size: 14px;
        color: #111827;
    }

    .create-dropdown__subtitle {
        font-size: 12px;
        color: #6b7280;
        margin-top: 2px;
    }

    .create-dropdown__item {
        width: 100%;
        display: flex;
        gap: 12px;
        align-items: flex-start;
        text-align: left;
        border: 0;
        background: transparent;
        padding: 10px;
        border-radius: 12px;
        cursor: pointer;
        transition: background .15s ease, transform .05s ease;
    }

        .create-dropdown__item:hover {
            background: rgba(17, 24, 39, 0.04);
        }

        .create-dropdown__item:active {
            transform: translateY(1px);
        }

    .create-dropdown__item-icon {
        width: 38px;
        height: 38px;
        border-radius: 12px;
        display: grid;
        place-items: center;
        background: rgba(59, 130, 246, 0.10);
        color: #2563eb;
        flex: 0 0 38px;
    }

    .create-dropdown__item-text {
        display: flex;
        flex-direction: column;
        gap: 2px;
        min-width: 0;
    }

    .create-dropdown__item-title {
        font-weight: 700;
        font-size: 13px;
        color: #111827;
    }

    .create-dropdown__item-subtitle {
        font-size: 12px;
        color: #6b7280;
        line-height: 1.25rem;
    }

    /* animação */
    .fade-scale-enter-active,
    .fade-scale-leave-active {
        transition: opacity .12s ease, transform .12s ease;
    }

    .fade-scale-enter,
    .fade-scale-leave-to {
        opacity: 0;
        transform: translateY(-6px) scale(.98);
    }

    /* Dark mode — create dropdown */
    [data-bs-theme="dark"] .create-dropdown__menu {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-color: #374151;
        box-shadow: 0 12px 32px rgba(0, 0, 0, 0.45);
    }

    [data-bs-theme="dark"] .create-dropdown__header {
        border-bottom-color: #374151;
    }

    [data-bs-theme="dark"] .create-dropdown__title {
        color: #f9fafb;
    }

    [data-bs-theme="dark"] .create-dropdown__subtitle {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .create-dropdown__item:hover {
        background: rgba(59, 130, 246, 0.12);
    }

    [data-bs-theme="dark"] .create-dropdown__item-title {
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .create-dropdown__item-subtitle {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .create-dropdown__item-icon {
        background: rgba(59, 130, 246, 0.22);
        color: #60a5fa;
    }

    .btn-outline-primary {
        min-height: 40px;
    }

    .border-danger {
        border-color: #E8B6C1 !important;
        box-shadow: 0 0 0 0.2rem rgba(196, 104, 110, 0.25);
    }

    /* Header Moderno */
    .modern-header {
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        padding: 12px 0;
        border-bottom: 1px solid #e5e7eb;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    }

    .modern-header .container {
        max-width: none !important;
    }

    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-bottom-color: #374151;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
        padding: 2px 0;
    }

    .title-section {
        flex: 0 0 auto;
        text-align: left;
        max-width: 500px;
        min-width: 0;
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .actions-group {
        display: flex;
        align-items: center;
        gap: 16px;
        flex-wrap: wrap;
        max-width: 100%;
        min-width: 0;
    }

    .modern-title {
        font-size: 32px;
        font-weight: 800;
        color: #1f2937;
        margin-bottom: 6px;
        letter-spacing: -0.5px;
        line-height: 1.2;
    }

    [data-bs-theme="dark"] .modern-title {
        color: #f9fafb;
    }

    .modern-subtitle {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        margin: 0;
    }

    [data-bs-theme="dark"] .modern-subtitle {
        color: #9ca3af;
    }

    .usage-badge {
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border: 2px solid #3b82f6;
        border-radius: 16px;
        padding: 20px 32px;
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
        min-width: 200px;
        margin-right: 12px;
        box-sizing: border-box;
    }

    [data-bs-theme="dark"] .usage-badge {
        background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);
        border-color: #3b82f6;
    }

    .buttons-container {
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: flex-start;
        width: fit-content;
        max-width: 100%;
    }

    .buttons-container.centered {
        align-items: center;
    }

    .buttons-row {
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
        width: fit-content;
        max-width: 100%;
        justify-content: center;
    }

    .status-badge {
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border: 2px solid #3b82f6;
        border-radius: 16px;
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
        width: 100%;
        max-width: 100%;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 36px;
        box-sizing: border-box;
        padding: 12px 16px;
    }

    .status-badge:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(59, 130, 246, 0.25);
        background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
    }

    .status-badge:active {
        transform: translateY(0);
    }

    [data-bs-theme="dark"] .status-badge {
        background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);
        border-color: #3b82f6;
    }

    [data-bs-theme="dark"] .status-badge:hover {
        background: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%);
        box-shadow: 0 6px 16px rgba(59, 130, 246, 0.35);
    }

    [data-bs-theme="dark"] .status-badge .badge-label {
        color: #93c5fd;
    }

    .badge-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        width: 100%;
    }

    .badge-label {
        font-size: 13px;
        font-weight: 600;
        color: #3b82f6;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        text-align: center;
    }

    .status-badge .badge-content {
        gap: 0;
    }

    .status-badge .badge-label {
        font-size: 14px;
        font-weight: 700;
    }

    [data-bs-theme="dark"] .badge-label {
        color: #93c5fd;
    }

    .badge-numbers {
        display: flex;
        align-items: baseline;
        gap: 4px;
        font-weight: 700;
    }

    .number-current {
        font-size: 24px;
        color: #1f2937;
    }

    [data-bs-theme="dark"] .number-current {
        color: #f9fafb;
    }

    .number-separator {
        font-size: 20px;
        color: #9ca3af;
        margin: 0 4px;
    }

    .number-total {
        font-size: 22px;
        color: #10b981;
        font-weight: 800;
    }

    @media (max-width: 480px) {
        .modern-header {
            padding: 16px 0;
        }

        .header-content {
            padding: 0 4px;
        }

        .title-section {
            margin-left: 4px;
            margin-right: 4px;
        }

        .modern-title {
            font-size: 20px;
        }

        .modern-subtitle {
            font-size: 12px;
        }

        .modern-btn {
            font-size: 13px;
            padding: 8px 14px;
        }

        .usage-badge,
        .status-badge {
            padding: 12px 16px;
        }

        .badge-label {
            font-size: 11px;
        }

        .number-current {
            font-size: 20px;
        }

        .number-separator {
            font-size: 18px;
        }

        .number-total {
            font-size: 20px;
        }

        /* Ajustes para botões de ação em telas pequenas */
        .action-btn {
            min-width: 0;
            max-width: 100%;
            padding: 10px 12px;
            font-size: 13px;
        }

        .action-btn svg {
            width: 16px;
            height: 16px;
        }
    }

    @media (max-width: 1200px) {
        .modern-header {
            padding: 20px 0;
        }

        .modern-header .container {
            padding-left: 16px;
            padding-right: 16px;
        }

        .header-content {
            flex-direction: column;
            text-align: left;
            gap: 16px;
            padding: 0;
        }

        .title-section {
            width: 100%;
            max-width: 100%;
            margin-left: 0;
            margin-right: 0;
        }

        .modern-title {
            font-size: 24px;
            word-wrap: break-word;
            overflow-wrap: break-word;
            hyphens: auto;
        }

        .modern-subtitle {
            font-size: 13px;
            word-wrap: break-word;
            overflow-wrap: break-word;
        }

        .actions-group {
            width: 100%;
            flex-direction: column;
            gap: 12px;
            align-items: stretch;
        }

        .buttons-container {
            width: 100%;
            align-items: stretch !important;
        }

        .buttons-row {
            flex-direction: column;
            gap: 8px;
            width: 100%;
        }

        .buttons-row .modern-btn {
            width: 100%;
            justify-content: center;
        }

        .usage-badge {
            width: 100%;
            max-width: 100%;
            margin-right: 0;
            padding: 16px 20px;
        }

        .status-badge {
            width: 100%;
            max-width: 100%;
            padding: 12px 16px;
        }

        .status-badge .badge-label {
            font-size: 12px;
            text-align: center;
            word-wrap: break-word;
            overflow-wrap: break-word;
        }
    }

    /* Botões Modernos */
    .modern-btn {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 8px 18px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        min-height: 36px;
        position: relative;
        overflow: hidden;
        white-space: nowrap;
        max-width: 100%;
        box-sizing: border-box;
    }

        .modern-btn::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 220%;
            height: 220%;
            border-radius: 50%;
            background: rgba(255,255,255,0.30);
            transform: translate(-50%, -50%) scale(0);
            transition: transform .6s ease;
            pointer-events: none;
        }

        .modern-btn:hover::before {
            transform: translate(-50%, -50%) scale(1);
        }

        .modern-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(31, 123, 255, 0.3);
        }

        .modern-btn:active {
            transform: translateY(0);
        }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
    }

        .modern-btn-primary:hover {
            background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
        }

    .modern-btn-secondary {
        background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
        color: white;
    }

        .modern-btn-secondary:hover {
            background: linear-gradient(135deg, #4b5563 0%, #374151 100%);
        }

    .modern-btn-warning {
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        color: white;
        box-shadow: 0 2px 8px rgba(245, 158, 11, 0.25);
    }

        .modern-btn-warning:hover {
            background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
            box-shadow: 0 8px 20px rgba(245, 158, 11, 0.35);
        }

    .modern-btn-success {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.25);
    }

        .modern-btn-success:hover {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
            box-shadow: 0 8px 20px rgba(16, 185, 129, 0.35);
        }

    .modern-btn-signature {
        background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
        color: white;
        box-shadow: 0 2px 8px rgba(139, 92, 246, 0.25);
    }

        .modern-btn-signature:hover {
            background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
            box-shadow: 0 8px 20px rgba(139, 92, 246, 0.35);
        }

    .search-row {
        display: flex;
        align-items: center;
        gap: 8px;
        flex: 1;
        min-width: 0;
    }

    .search-box {
        position: relative;
        flex: 1;
        min-width: 0;
    }

    @media (max-width: 1200px) {
        .search-box {
            width: 100%;
        }
    }

    .search-icon {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        color: #9ca3af;
        pointer-events: none;
        z-index: 1;
    }

    @media (max-width: 480px) {
        .search-icon {
            left: 12px;
            width: 16px;
            height: 16px;
        }
    }

    .modern-search-input {
        width: 100%;
        padding: 10px 16px 10px 46px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        font-size: 14px;
        transition: all 0.3s ease;
        background: #f9fafb;
        height: 44px;
    }

    @media (max-width: 480px) {
        .modern-search-input {
            padding: 8px 12px 8px 38px;
            font-size: 13px;
            height: 40px;
        }

        .search-filter-btn {
            width: 40px;
            height: 40px;
        }
    }

        .modern-search-input:focus {
            outline: none;
            border-color: #2563eb;
            background: white;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
        }

    [data-bs-theme="dark"] .modern-search-input {
        background: #1f2937;
        border-color: #374151;
        color: #e5e7eb;
    }

        [data-bs-theme="dark"] .modern-search-input:focus {
            background: #111827;
            border-color: #3b82f6;
        }

    .search-filter-btn {
        position: relative;
        flex-shrink: 0;
        width: 44px;
        height: 44px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        background: #f9fafb;
        color: #6b7280;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s ease;
    }

        .search-filter-btn:hover {
            background: #e5e7eb;
            color: #2563eb;
            border-color: #d1d5db;
        }

        .search-filter-btn.is-active {
            background: #dbeafe;
            color: #2563eb;
            border-color: #93c5fd;
        }

    .search-filter-badge {
        position: absolute;
        top: 6px;
        right: 6px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #2563eb;
        border: 1px solid #fff;
    }

    .list-filters-box {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        gap: 12px;
        padding: 16px 20px;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        background: linear-gradient(to bottom, #ffffff 0%, #fafafa 100%);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    }

    .filter-clear-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        height: 40px;
        padding: 8px 16px;
        margin-left: auto;
        border: 2px solid #e5e7eb;
        border-radius: 8px;
        background: #fff;
        color: #4b5563;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
        white-space: nowrap;
    }

        .filter-clear-btn:hover:not(:disabled) {
            background: #f3f4f6;
            color: #1f2937;
            border-color: #d1d5db;
        }

        .filter-clear-btn:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }

    .filter-field {
        display: flex;
        flex-direction: column;
        gap: 6px;
        min-width: 220px;
        flex: 1;
        max-width: 360px;
    }

    .filter-label {
        font-size: 12px;
        font-weight: 600;
        color: #4b5563;
        margin: 0;
    }

    .filter-select {
        width: 100%;
        padding: 8px 12px;
        border: 2px solid #e5e7eb;
        border-radius: 8px;
        font-size: 14px;
        background: #fff;
        color: #111827;
        transition: all 0.2s ease;
        height: 40px;
    }

        .filter-select:focus {
            outline: none;
            border-color: #2563eb;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
        }

    .slide-filters-enter-active,
    .slide-filters-leave-active {
        transition: opacity .18s ease, transform .18s ease;
    }

    .slide-filters-enter,
    .slide-filters-leave-to {
        opacity: 0;
        transform: translateY(-8px);
    }

    [data-bs-theme="dark"] .search-filter-btn {
        background: #1f2937;
        border-color: #374151;
        color: #9ca3af;
    }

        [data-bs-theme="dark"] .search-filter-btn:hover {
            background: #374151;
            color: #93c5fd;
        }

        [data-bs-theme="dark"] .search-filter-btn.is-active {
            background: rgba(59, 130, 246, 0.2);
            color: #93c5fd;
            border-color: #3b82f6;
        }

    [data-bs-theme="dark"] .search-filter-badge {
        border-color: #1f2937;
    }

    [data-bs-theme="dark"] .list-filters-box {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    [data-bs-theme="dark"] .filter-clear-btn {
        background: #111827;
        border-color: #374151;
        color: #d1d5db;
    }

        [data-bs-theme="dark"] .filter-clear-btn:hover:not(:disabled) {
            background: #374151;
            color: #f9fafb;
            border-color: #4b5563;
        }

    [data-bs-theme="dark"] .filter-label {
        color: #d1d5db;
    }

    [data-bs-theme="dark"] .filter-select {
        background: #111827;
        border-color: #374151;
        color: #e5e7eb;
    }

        [data-bs-theme="dark"] .filter-select:focus {
            border-color: #3b82f6;
        }

    /* Botões de Ação na Tabela */
    .actions-header {
        padding-right: 60px !important;
    }

    .action-cell {
        white-space: nowrap;
        padding-right: 60px !important;
        position: relative;
        overflow: visible;
    }

    .action-buttons {
        display: flex;
        gap: 8px;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .action-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 14px;
        border-radius: 8px;
        font-weight: 600;
        font-size: 13px;
        cursor: pointer;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        border: 2px solid transparent;
        white-space: nowrap;
        position: relative;
        overflow: hidden;
        max-width: 100%;
        box-sizing: border-box;
    }

        .action-btn::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 220%;
            height: 220%;
            border-radius: 50%;
            background: rgba(255,255,255,0.30);
            transform: translate(-50%, -50%) scale(0);
            transition: transform .6s ease;
            pointer-events: none;
        }

        .action-btn:hover::before {
            transform: translate(-50%, -50%) scale(1);
        }

    .action-btn-view {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
        border-color: transparent;
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
    }

        .action-btn-view:hover {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
        }

    .action-dropdown {
        display: inline-flex;
        position: relative;
    }

    .action-btn-more {
        width: 40px;
        height: 40px;
        min-width: 40px;
        padding: 0;
        justify-content: center;
        background: #ffffff;
        color: #64748b;
        border: 1px solid #e2e8f0;
        border-radius: 10px;
        box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
    }

        .action-btn-more::before {
            background: rgba(37, 99, 235, 0.08);
        }

        .action-btn-more:hover,
        .action-dropdown.show > .action-btn-more {
            background: linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%);
            color: #2563eb;
            border-color: #bfdbfe;
            transform: translateY(-1px);
            box-shadow: 0 6px 16px rgba(37, 99, 235, 0.18);
        }

    .action-dropdown .dropdown-toggle::after {
        display: none;
    }

    .action-dropdown-menu {
        border-radius: 14px;
        border: 1px solid rgba(226, 232, 240, 0.95);
        box-shadow: 0 20px 50px rgba(15, 23, 42, 0.16), 0 8px 20px rgba(15, 23, 42, 0.08);
        padding: 0.375rem;
        min-width: 196px;
        margin-top: 6px !important;
        z-index: 1060 !important;
        animation: actionMenuIn 0.18s ease;
    }

    @keyframes actionMenuIn {
        from {
            opacity: 0;
            transform: translateY(-6px) scale(0.98);
        }

        to {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }

    .action-dropdown-item {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        width: 100%;
        padding: 0.7rem 0.85rem;
        border: none;
        border-radius: 10px;
        background: transparent;
        color: #334155;
        font-weight: 600;
        font-size: 13px;
        text-align: left;
        cursor: pointer;
        transition: all 0.2s ease;
    }

        .action-dropdown-item:hover {
            background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
            color: #1d4ed8;
            transform: translateX(3px);
        }

        .action-dropdown-item svg {
            flex-shrink: 0;
            color: #3b82f6;
        }

    .action-dropdown-item-delete {
        color: #b91c1c;
    }

        .action-dropdown-item-delete svg {
            color: #ef4444;
        }

        .action-dropdown-item-delete:hover {
            background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
            color: #dc2626;
        }

            .action-dropdown-item-delete:hover svg {
                color: #dc2626;
            }

    [data-bs-theme="dark"] .action-btn-more {
        background: #1e293b;
        color: #94a3b8;
        border-color: #334155;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
    }

        [data-bs-theme="dark"] .action-btn-more:hover,
        [data-bs-theme="dark"] .action-dropdown.show > .action-btn-more {
            background: linear-gradient(135deg, #1e3a8a 0%, #1e293b 100%);
            color: #93c5fd;
            border-color: #3b82f6;
            box-shadow: 0 6px 16px rgba(37, 99, 235, 0.25);
        }

    [data-bs-theme="dark"] .action-dropdown-menu {
        background: #1e293b;
        border-color: #334155;
        box-shadow: 0 20px 50px rgba(0, 0, 0, 0.45), 0 8px 20px rgba(0, 0, 0, 0.3);
    }

    [data-bs-theme="dark"] .action-dropdown-item {
        color: #cbd5e1;
    }

        [data-bs-theme="dark"] .action-dropdown-item:hover {
            background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%);
            color: #e2e8f0;
        }

        [data-bs-theme="dark"] .action-dropdown-item svg {
            color: #93c5fd;
        }

    [data-bs-theme="dark"] .action-dropdown-item-delete {
        color: #fca5a5;
    }

        [data-bs-theme="dark"] .action-dropdown-item-delete svg {
            color: #f87171;
        }

        [data-bs-theme="dark"] .action-dropdown-item-delete:hover {
            background: linear-gradient(135deg, #7f1d1d 0%, #991b1b 100%);
            color: #fecaca;
        }

            [data-bs-theme="dark"] .action-dropdown-item-delete:hover svg {
                color: #fecaca;
            }

    .dark .action-dropdown-menu {
        background: #1e293b;
        border-color: #334155;
        box-shadow: 0 20px 50px rgba(0, 0, 0, 0.45), 0 8px 20px rgba(0, 0, 0, 0.3);
    }

    .dark .action-dropdown-item {
        color: #cbd5e1;
    }

        .dark .action-dropdown-item:hover {
            background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%);
            color: #e2e8f0;
        }

    .dark .action-dropdown-item-delete {
        color: #fca5a5;
    }

        .dark .action-dropdown-item-delete:hover {
            background: linear-gradient(135deg, #7f1d1d 0%, #991b1b 100%);
            color: #fecaca;
        }

    .dark .action-btn-more {
        background: #1e293b;
        color: #94a3b8;
        border-color: #334155;
    }

        .dark .action-btn-more:hover,
        .dark .action-dropdown.show > .action-btn-more {
            background: linear-gradient(135deg, #1e3a8a 0%, #1e293b 100%);
            color: #93c5fd;
            border-color: #3b82f6;
        }

    .action-btn:active {
        transform: translateY(0);
    }

    @media (min-width: 1201px) and (max-width: 1400px) {
        .action-btn {
            padding: 8px 12px;
            font-size: 13px;
            gap: 4px;
        }

        .action-text {
            font-size: 12px;
        }
    }

    .th-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 4px;
        min-height: 20px;
    }

    .th-title {
        text-align: center;
        font-weight: 700;
        letter-spacing: 0.3px;
    }

    .th-wrapper.left {
        align-items: center;
        justify-content: flex-start;
        padding: 0;
        gap: 4px;
    }

    .btn-sort {
        position: absolute;
        right: -16px;
        top: 50%;
        transform: translateY(-45%);
        padding: 4px;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;
    }

        .btn-sort:hover {
            transform: translateY(-45%) scale(1.1);
        }

    .btn-sort-inline {
        position: relative;
        top: 50%;
        transform: translateY(5%);
        padding: 4px;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;
        margin-left: 8px;
    }

        .btn-sort-inline:hover {
            transform: translateY(5%) scale(1.1);
        }

    .tyn-root,
    .tyn-content,
    .tyn-main,
    .tyn-section {
        min-width: 0;
        max-width: 100%;
    }

    .table-container {
        display: flex;
        justify-content: center;
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding-top: 22px;
        padding-bottom: 0px;
        padding-left: 16px;
        padding-right: 16px;
    }

    @media (max-width: 1200px) {
        .table-container {
            padding-left: 8px;
            padding-right: 8px;
        }
    }

    .table-wrapper {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        padding: 0 10px;
        margin: 0 auto;
        overflow-x: auto;
        min-height: 700px;
        display: flex;
        flex-direction: column;
        gap: 12px;
        box-sizing: border-box;
    }

    @media (max-width: 1200px) {
        .table-wrapper {
            padding: 0 4px;
            min-height: 500px;
        }
    }

    .custom-table {
        width: 100%;
        border: 1px solid #e5e7eb;
        border-radius: 0;
        box-shadow: none;
        border-collapse: collapse;
        background: white;
    }

        .custom-table th,
        .custom-table td {
            padding: 16px 20px;
            text-align: left;
            border-bottom: 1px solid #f3f4f6;
            transition: all 0.2s ease;
        }

        .custom-table td {
            font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
            font-size: 15px;
            color: #374151;
        }

        .custom-table th {
            font-weight: 700;
            font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
            font-size: 14px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

    [data-bs-theme="dark"] .custom-table {
        background: #1f2937;
    }

        [data-bs-theme="dark"] .custom-table td {
            color: #e5e7eb;
        }

    .custom-table-footer {
        border: 1px solid #e5e7eb;
        border-top: none;
        border-radius: 0 0 12px 12px;
        padding: 16px 20px;
        display: flex;
        justify-content: space-between;
        font-family: 'Segoe UI';
        align-items: center;
        font-weight: 600;
        font-size: 14px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
        flex-wrap: wrap;
        gap: 12px;
    }

    @media (max-width: 1200px) {
        .custom-table-footer {
            padding: 16px;
            flex-direction: column;
            align-items: center;
            font-size: 13px;
            gap: 16px;
        }

        .custom-table-footer > span {
            order: 2;
            text-align: center;
            width: 100%;
            padding: 8px 0;
            background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
            border-radius: 8px;
            color: #374151;
        }

        .pagination-controls {
            order: 1;
            width: 100%;
            max-width: 100%;
            min-width: 0;
        }
    }

    [data-bs-theme="dark"] {
        @media (max-width: 1200px) {
            .custom-table-footer > span {
                background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
                color: #e5e7eb;
            }
        }
    }

    [data-bs-theme="dark"] .custom-table-footer {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
    }

    .pagination-controls {
        display: flex;
        gap: 6px;
        flex-wrap: wrap;
        justify-content: center;
    }

    @media (max-width: 1200px) {
        .pagination-controls {
            gap: 8px;
            padding: 8px 0;
        }
    }

    @media (max-width: 480px) {
        .pagination-controls {
            gap: 6px;
            padding: 4px 0;
        }
    }

    .list-toolbar {
        background: linear-gradient(to bottom, #ffffff 0%, #fafafa 100%);
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        padding: 16px 20px;
        display: flex;
        align-items: center;
        gap: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        flex-wrap: wrap;
        flex-shrink: 0;
    }

    @media (max-width: 1200px) {
        .list-toolbar {
            padding: 12px 16px;
            flex-direction: column;
            align-items: stretch;
        }

        .search-row {
            width: 100%;
            min-width: 0;
        }

        .filter-field {
            min-width: 0;
            max-width: 100%;
            flex: 1 1 100%;
        }

        .list-filters-box,
        .list-toolbar,
        .custom-table-footer {
            max-width: 100%;
            min-width: 0;
            box-sizing: border-box;
        }
    }

    [data-bs-theme="dark"] .list-toolbar {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    .list-grid-box {
        border-radius: 12px;
        overflow-x: auto;
        max-width: 100%;
        min-width: 0;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        background: #fff;
    }

    [data-bs-theme="dark"] .list-grid-box {
        background: #1f2937;
    }

    .page-box {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 38px;
        height: 38px;
        border: 2px solid #e5e7eb;
        border-radius: 8px;
        line-height: 1;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        background: white;
    }

    @media (max-width: 1200px) {
        .page-box {
            width: 40px;
            height: 40px;
            font-size: 14px;
            border-width: 2px;
            font-weight: 700;
            flex-shrink: 0;
        }

        .page-box:hover {
            transform: scale(1.05);
        }

        .navigation-symbol {
            font-size: 20px;
        }
    }

    @media (max-width: 480px) {
        .page-box {
            width: 36px;
            height: 36px;
            font-size: 13px;
            flex-shrink: 0;
        }

        .page-box:hover {
            transform: scale(1.03);
        }

        .navigation-symbol {
            font-size: 18px;
        }
    }

    @media (max-width: 360px) {
        .page-box {
            width: 32px;
            height: 32px;
            font-size: 12px;
        }

        .navigation-symbol {
            font-size: 16px;
        }

        .pagination-controls {
            gap: 4px;
        }
    }

        .page-box:hover {
            background-color: #f3f4f6;
            border-color: #2563eb;
            transform: translateY(-2px);
            box-shadow: 0 2px 8px rgba(37, 99, 235, 0.15);
        }

        .page-box.disabled {
            opacity: 0.4;
            pointer-events: none;
            cursor: default;
        }

        .page-box.btn.btn-primary-soft {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            color: white;
            border-color: #2563eb;
            box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
        }

            .page-box.btn.btn-primary-soft:hover {
                background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
                transform: none;
            }

    [data-bs-theme="dark"] .page-box {
        background-color: #1e293b;
        border: 2px solid #334155;
        color: #cbd5e1;
    }

        [data-bs-theme="dark"] .page-box:hover {
            background-color: #334155;
            border-color: #3b82f6;
        }

        [data-bs-theme="dark"] .page-box.btn.btn-primary-soft {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            color: white;
            border: 2px solid #3b82f6;
        }

    .navigation-symbol {
        display: inline-block;
        line-height: 1;
        font-size: 18px;
        font-weight: 700;
    }

    .custom-table-button {
        background-color: #E0F2FE;
        color: #2563EB;
        padding: 8px 16px;
        border-radius: 8px;
        font-weight: 600;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        padding: 0 16px;
        border: 2px solid transparent;
        height: 38px;
    }

        .custom-table-button:hover {
            background-color: #2563EB;
            color: white;
            border-color: #2563eb;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
        }

    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.6);
        backdrop-filter: blur(4px);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 999;
        animation: fadeIn 0.2s ease-out;
        padding: 20px;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }

    @keyframes slideUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .modal-content-custom {
        background: white;
        padding: 32px;
        border-radius: 12px;
        width: 800px;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    }

    [data-bs-theme="dark"] .modal-content-custom {
        background: #1f2937;
    }


    .custom-table tbody tr {
        position: relative;
        transition: background-color 0.2s ease, box-shadow 0.2s ease;
    }

        .custom-table tbody tr:has(.dropdown.show) {
            z-index: 40;
        }

        .custom-table tbody tr:hover {
            background-color: #f9fafb;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        }

    [data-bs-theme="dark"] .custom-table tbody tr:hover {
        background-color: #374151;
        color: white;
    }

    .btn-outline-danger,
    .btn-outline-success {
        padding: 7px 7px;
        border-radius: 8px;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 32px;
        line-height: 1;
        gap: 6px;
        margin-right: 6px;
    }

    .separador {
        height: 2px;
        background: linear-gradient(to right, transparent, #e5e7eb 20%, #e5e7eb 80%, transparent);
        margin-top: 12px;
        margin-bottom: 20px;
    }

    /* Avatares Modernos */
    .avatar-wrapper {
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }

    .modern-avatar {
        width: 44px;
        height: 44px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        border: 3px solid white;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        cursor: pointer;
    }

        .modern-avatar:hover {
            transform: scale(1.1) translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }

        .modern-avatar img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

    .avatar-initials {
        color: white;
        font-weight: 700;
        font-size: 16px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .avatar-small {
        width: 38px;
        height: 38px;
        border-radius: 10px;
        border: 2px solid white;
    }

        .avatar-small .avatar-initials {
            font-size: 14px;
        }

    .avatars-group {
        display: inline-flex;
        gap: -8px;
        justify-content: center;
        align-items: center;
    }

        .avatars-group .modern-avatar {
            margin-left: -8px;
        }

            .avatars-group .modern-avatar:first-child {
                margin-left: 0;
            }

            .avatars-group .modern-avatar:hover {
                z-index: 10;
            }

    .btn-md {
        z-index: 1000;
    }

    [data-bs-theme="dark"] .modern-avatar {
        border-color: #1f2937;
    }

    /* Estado Vazio */
    .empty-state {
        padding: 80px 20px !important;
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
    }

    [data-bs-theme="dark"] .empty-state {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
    }

    .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        animation: fadeInUp 0.5s ease-out;
    }

    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .empty-icon {
        color: #cbd5e1;
        margin-bottom: 8px;
    }

    [data-bs-theme="dark"] .empty-icon {
        color: #475569;
    }

    .empty-title {
        font-size: 24px;
        font-weight: 700;
        color: #1f2937;
        margin: 0;
    }

    [data-bs-theme="dark"] .empty-title {
        color: #f9fafb;
    }

    .empty-description {
        font-size: 16px;
        color: #6b7280;
        margin: 0;
    }

    [data-bs-theme="dark"] .empty-description {
        color: #9ca3af;
    }

    /* Badges de ID e Número */
    .id-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 48px;
        padding: 6px 12px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        color: #2563eb;
        border-radius: 8px;
        font-weight: 700;
        font-size: 14px;
        border: 2px solid #bfdbfe;
        transition: all 0.2s ease;
    }

        .id-badge:hover {
            transform: scale(1.05);
            box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
        }

    [data-bs-theme="dark"] .id-badge {
        background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);
        color: #93c5fd;
        border-color: #3b82f6;
    }

    .number-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 6px 12px;
        background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
        color: #374151;
        border-radius: 8px;
        font-weight: 600;
        font-size: 13px;
        border: 2px solid #d1d5db;
        font-family: 'Courier New', monospace;
        transition: all 0.2s ease;
    }

        .number-badge:hover {
            transform: scale(1.05);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

    [data-bs-theme="dark"] .number-badge {
        background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
        color: #e5e7eb;
        border-color: #6b7280;
    }

    .process-name {
        font-weight: 600;
        color: #1f2937;
        font-size: 15px;
        transition: color 0.2s ease;
    }

        .process-name:hover {
            color: #2563eb;
        }

    [data-bs-theme="dark"] .process-name {
        color: #f3f4f6;
    }

        [data-bs-theme="dark"] .process-name:hover {
            color: #93c5fd;
        }

    /* Cobre o Galaxy A14 (1080 físicos, ~360–920 CSS e paisagem) para a grade não estourar a tela. */
    @media (max-width: 1200px) {
        .custom-table,
        .custom-table thead,
        .custom-table tbody,
        .custom-table th,
        .custom-table td,
        .custom-table tr {
            display: block;
            width: 100%;
            max-width: 100%;
            min-width: 0;
            box-sizing: border-box;
        }

            .custom-table thead {
                display: none;
            }

            .custom-table tr {
                margin-bottom: 16px;
                border-radius: 12px;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
                overflow: hidden;
                border: 1px solid #e5e7eb;
            }

            .custom-table td {
                text-align: left !important;
                padding: 14px 16px;
                position: relative;
                border: none;
                border-bottom: 1px solid #f3f4f6;
                overflow-wrap: anywhere;
                word-break: break-word;
            }

                .custom-table td::before {
                    content: attr(data-label);
                    font-weight: 700;
                    display: block;
                    margin-bottom: 6px;
                    color: #4b5563;
                    font-size: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                .custom-table td:last-child {
                    border-bottom: none;
                    padding: 16px !important;
                    background: #f9fafb;
                }

        /* Remove padding extra da coluna de ações no responsivo */
        .action-cell {
            padding: 16px !important;
            white-space: normal !important;
            overflow: visible;
        }

        /* Melhorias nos botões de ação no modo responsivo */
        .action-buttons {
            flex-direction: row;
            gap: 10px;
            justify-content: flex-start;
            flex-wrap: wrap;
            width: 100%;
            max-width: 100%;
        }

        .action-btn {
            flex: 1 1 auto;
            min-width: 0;
            max-width: 100%;
            justify-content: center;
            padding: 12px 16px;
            font-size: 14px;
            min-height: 44px;
            touch-action: manipulation;
        }

        .action-btn svg {
            width: 18px;
            height: 18px;
            flex-shrink: 0;
        }

        .action-text {
            display: inline;
            font-weight: 600;
            min-width: 0;
        }

        .action-btn:active {
            transform: scale(0.98);
        }

        .action-btn-view {
            flex: 1 1 auto;
        }

        .action-btn-more {
            flex: 0 0 48px;
            width: 48px;
            height: 48px;
            min-width: 48px;
            max-width: 48px;
            padding: 0;
        }

        /* Avatares menores no responsivo */
        .modern-avatar {
            width: 36px;
            height: 36px;
        }

        .avatar-small {
            width: 32px;
            height: 32px;
        }

        .avatars-group {
            justify-content: flex-start;
            flex-wrap: wrap;
            max-width: 100%;
        }

        /* Badges responsivos */
        .id-badge,
        .number-badge {
            font-size: 13px;
            padding: 6px 10px;
            max-width: 100%;
            white-space: normal;
            overflow-wrap: anywhere;
            box-sizing: border-box;
        }

        .process-name {
            font-size: 14px;
            display: block;
            margin-top: 2px;
            max-width: 100%;
            overflow-wrap: anywhere;
            word-break: break-word;
        }
    }

    /* Dark theme para cards responsivos */
    [data-bs-theme="dark"] {
        @media (max-width: 1200px) {
            .custom-table tr {
                border-color: #374151;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
            }

            .custom-table td {
                border-bottom-color: #374151;
            }

            .custom-table td::before {
                color: #9ca3af;
            }

            .custom-table td:last-child {
                background: #1f2937;
            }
        }
    }

    .modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
    }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 32px 32px 20px;
        position: relative;
    }

        .modal-modern-header::after {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 32px;
            right: 32px;
            height: 1px;
            background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
        }

        .modal-modern-header .header-icon {
            width: 64px;
            height: 64px;
            border-radius: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(16, 185, 129, 0.12) 100%);
            color: #2563eb;
        }

        .modal-modern-header .header-text h2 {
            margin: 0;
            font-size: 24px;
            font-weight: 700;
            color: #0f172a;
        }

        .modal-modern-header .header-text p {
            margin-top: 6px;
            margin-bottom: 0;
            color: #475569;
            font-size: 14px;
            max-width: 420px;
            line-height: 1.4;
        }

    .modal-modern-body {
        padding: 28px 32px;
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .form-grid {
        display: grid;
        gap: 18px;
    }

    .form-grid-3 {
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    }

    .form-grid-2 {
        grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .form-group-inline {
        display: flex;
        align-items: center;
        gap: 16px;
        flex-wrap: wrap;
    }

        .form-group-inline .info-chip {
            display: inline-flex;
            align-items: flex-start;
            gap: 8px;
            padding: 12px 16px;
            border-radius: 12px;
            background: rgba(37, 99, 235, 0.08);
            color: #1e3a8a;
            font-size: 13px;
            line-height: 1.4;
            max-width: 380px;
        }

    .form-textarea {
        min-height: 110px;
        resize: vertical;
    }

    .modal-modern-footer {
        padding: 0 32px 32px;
    }

    .btn-close-modern {
        position: absolute;
        top: 18px;
        right: 18px;
        width: 44px;
        height: 44px;
        border-radius: 50% !important;
        background: #ffffff !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 10px 30px rgba(15, 23, 42, 0.12);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

        .btn-close-modern svg {
            color: #334155;
        }

        .btn-close-modern:hover {
            transform: scale(1.07);
            box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
            border-color: transparent !important;
        }

            .btn-close-modern:hover svg {
                color: #ffffff;
            }

    .btn-modern-primary {
        border: none;
        border-radius: 12px;
        padding: 14px 20px;
        font-weight: 700;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.35);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

        .btn-modern-primary:hover {
            transform: translateY(-2px);
            box-shadow: 0 16px 32px rgba(37, 99, 235, 0.4);
        }

        .btn-modern-primary:active {
            transform: translateY(0);
        }

    .modern-modal .form-control {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        background-color: #ffffff;
        padding: 12px 16px;
        font-size: 14px;
        color: #1f2937;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

        .modern-modal .form-control:focus {
            border-color: rgba(37, 99, 235, 0.6);
            box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
            background-color: #ffffff;
        }

    .modern-modal select.form-control {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-color: #ffffff;
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%23838B99' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 14px 9px;
        padding-right: 46px;
        cursor: pointer;
    }

    .modern-modal .form-label {
        font-weight: 600;
        color: #0f172a;
        font-size: 13px;
        letter-spacing: 0.3px;
        text-transform: uppercase;
    }

    .modern-modal small.text-muted {
        color: #64748b;
    }

    @media (max-width: 1200px) {
        .modal-modern-header,
        .modal-modern-body,
        .modal-modern-footer {
            padding: 24px 20px;
        }

        .modal-modern-header {
            flex-direction: column;
            align-items: stretch;
            gap: 14px;
        }

            .modal-modern-header::after {
                left: 20px;
                right: 20px;
            }

            .modal-modern-header .header-icon {
                width: 56px;
                height: 56px;
            }

        .form-group-inline {
            flex-direction: column;
            align-items: stretch;
        }
    }

    @media (max-width: 576px) {
        .modern-modal .modal-dialog {
            margin: 12px;
        }

        .modal-modern-header .header-text h2 {
            font-size: 22px;
        }

        .modal-modern-header .header-text p {
            font-size: 13px;
        }
    }

    [data-bs-theme="dark"] .modern-modal .modal-modern-content {
        background: linear-gradient(135deg, #0f172a 0%, #111826 100%) !important;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .modal-modern-header .header-icon {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.18) 0%, rgba(45, 212, 191, 0.18) 100%);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text h2 {
        color: #f8fafc;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text p {
        color: #94a3b8;
    }


    [data-bs-theme="dark"] .modal-modern-body {
        background: transparent;
    }

    [data-bs-theme="dark"] .modern-modal .form-control {
        background-color: rgba(15, 23, 42, 0.8);
        border-color: rgba(148, 163, 184, 0.2);
        color: #e2e8f0;
    }

        [data-bs-theme="dark"] .modern-modal .form-control:focus {
            background-color: rgba(15, 23, 42, 0.95);
        }

    [data-bs-theme="dark"] .modern-modal select.form-control,
    [data-bs-theme="dark"] .modern-modal select.form-control:focus {
        background-color: rgba(15, 23, 42, 0.8);
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%2394A3B8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 14px 9px;
    }

        [data-bs-theme="dark"] .modern-modal select.form-control:focus {
            background-color: rgba(15, 23, 42, 0.95);
        }

    [data-bs-theme="dark"] .modern-modal select.form-control option {
        background: #1f2937;
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modern-modal .form-label {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modal-modern-header::after {
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.25), transparent);
    }

    [data-bs-theme="dark"] .modal-modern-footer {
        background: transparent;
    }

    [data-bs-theme="dark"] .form-group-inline .info-chip {
        background: rgba(37, 99, 235, 0.15);
        color: #cbd5f5;
    }

    [data-bs-theme="dark"] .modern-modal small.text-muted {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .btn-close-modern {
        background: rgba(15, 23, 42, 0.9) !important;
        border-color: rgba(148, 163, 184, 0.25) !important;
    }

        [data-bs-theme="dark"] .btn-close-modern svg {
            color: #e2e8f0;
        }

        [data-bs-theme="dark"] .btn-close-modern:hover {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
        }

    [data-bs-theme="dark"] .btn-modern-primary {
        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.45);
    }

    [data-bs-theme="dark"] .modern-modal .form-control::placeholder {
        color: #64748b;
    }
</style>

